import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import Moment from "moment";
import Select from "react-select";
import NumericInput from 'react-numeric-input';

export default class AddDynamicLinksModal extends Component {
    constructor(props) {
        super(props);
    }

    handleClose = () => fetch('https://back-api.therunningcollective.fr/dynamic-link', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.props.selectedDynamicLink)
    })
        .then( () => (this.props.closeModal, window.location.reload(false)))
        .catch( err =>
            console.log(err)
        );
    
    render(){

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Créer un dynamic link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Nom : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedDynamicLink.name = e.target.value} defaultValue={this.props.selectedDynamicLink.name} placeholder="Page Podcasts"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Lien : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedDynamicLink.link = e.target.value} defaultValue={this.props.selectedDynamicLink.link} placeholder="https://app.therunningcollective.fr/podcasts"/>
                                        </Form.Group>
                                        { this.props.selectedDynamicLink.dynamicLink && this.props.selectedDynamicLink.dynamicLink != ""?
                                            <Form.Group >
                                                <Form.Label>Dynamic Link créé : </Form.Label>
                                                <Form.Control disabled type="text" onChange={(e) => this.props.selectedDynamicLink.dynamicLink = e.target.value} defaultValue={this.props.selectedDynamicLink.dynamicLink} placeholder="https://therunningcollective.page.link/ABCD"/>
                                            </Form.Group>
                                            : null
                                        }
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={() => this.handleClose()}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}